import React, { useEffect, useRef, useState } from 'react';
import { useT } from '../i18n';
import PhotoGuide from './PhotoGuide';

export default function ImageTips() {
  const t = useT();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <div className="image-tips" ref={wrapRef}>
      <button
        type="button"
        className="image-tips-trigger"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-haspopup="dialog"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="16" x2="12" y2="12" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
        <span>{t.imageTipsTrigger}</span>
      </button>

      {open && (
        <div className="image-tips-popover" role="dialog" aria-label={t.imageTipsTitle}>
          <div className="image-tips-popover-head">
            <strong>{t.imageTipsTitle}</strong>
            <button
              type="button"
              className="image-tips-close"
              onClick={() => setOpen(false)}
              aria-label={t.imageTipsClose}
            >
              ×
            </button>
          </div>
          {/* The worked example leads — a parent understands the framing from
              one look at it far faster than from the six bullets below. */}
          <PhotoGuide />
          <ul className="image-tips-list">
            {t.imageTipsItems.map((tip, i) => (
              <li key={i}>{tip}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
